<template>
  <div class="adLine">
    <el-image
      class="adItem"
      v-for="(item, index) in showList"
      :key="index"
      :src="item.tabImageUrl"
      :fit="'cover'"
      @click="onJump(item)"
    ></el-image>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showList: [],
    };
  },
  created() {
    this.getAdList();
  },
  methods: {
    onJump(res) {
      window.open(res.pcLink, "_blank");
    },
    getAdList() {
      this.$http
        .post("/front/oms/sys/oms-shopping-home-banner-config/list", {
          // 位置为首页广告的
          location:[1],
          pageNo: 1,
          pageSize: 10000,
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.showList = (res.data.records || []).filter(
              (i) => i.location === 1 && i.visibleState
            ).slice(0,4).filter((i) => i);
          }
          console.log("getAdList", this.showList);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.adLine {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .adItem {
    width: 292px;
    height: 164px;
    border-radius: 16px;
    cursor: pointer;
  }
}
</style>
